


import {get,post} from '@/utils/request';// 这个就是我们上面的http.js文件




let saveConcat = (data)=>post('/concat/saveConcat',data)
let register = (data)=>post('/independentLogin/register',data)
let toLogin = (data)=>post('/independentLogin/toLogin',data)
let forgetPassWord = (data)=>post('/independentUser/forgetPassWord',data)
let getCheckCode = (data)=>get('/independentLogin/getCheckCode',data)
let getIndependentOrder = (data)=>post('/independentOrder/getIndependentOrderByUserId',data)
let subIndependentOrder = (data)=>post('/independentOrder/subIndependentOrder',data)
let payment = (data)=>post('/payment/pay',data)
let pageIndependentProduct = (data)=>post('/independentProduct/pageIndependentProduct',data)
let getProductInfo = (data)=>get('/independentProduct/getProductInfo',data)
let getLogisticsInfo = (data)=>post('/trancking/pageIndependentTrancking',data)
let pagepageIndependentArticalInfo = (data)=>post('/training/pageIndependentTraining',data)
let pageIndependentDownload= (data)=>post('/download/pageIndependentDownload',data)//下载
let getArticalInfo = (data)=>get('/training/getTrainingInfo',data)
export {
    saveConcat,
    register,
    toLogin,
    forgetPassWord,
    getCheckCode,
    getIndependentOrder,
    payment,
    subIndependentOrder,
    pageIndependentProduct,
    getProductInfo,
    getLogisticsInfo,
    pagepageIndependentArticalInfo,
    pageIndependentDownload,
    getArticalInfo
}